import Vue from "vue";
import Router from "vue-router";

// pages
import Nodes from "@/pages/Nodes";
import Wordlists from "@/pages/Wordlists";
import EditFile from "@/pages/EditFile";
import Atoms from "@/pages/Atoms";
import AddAssets from "@/components/AddAssets";
import SingleScope from "@/components/SingleScope";
import SingleWordlist from "@/components/SingleWordlist";


import SingleAtom from "@/components/SingleAtom";
import NewAtom from "@/components/NewAtom";

import Sched from "@/pages/Sched";
import NodeTasks from "@/pages/NodeTasks";
import SingleTask from "@/pages/SingleTask";
import SingleSchedTask from "@/pages/SingleSchedTask";
import NewTask from "@/components/NewTask";
import NewNodeTask from "@/components/NewNodeTask";
import Events from "@/components/Events";
import SettingsTeam from "@/components/SettingsTeam";
import Storage from "@/pages/Storage";
import Logs from "@/pages/Logs";

import Templates from "@/pages/Templates.vue";
import SingleTemplate from "@/pages/SingleTemplate";
import Vulnerabilities from "@/pages/Vulnerabilities.vue";
import SingleVulnerability from "@/pages/SingleVulnerability";

import Test from "@/components/Test";

//import VueDataTables from "vue-data-tables ";
//Vue.use(VueDataTables);
Vue.use(Router);


export default new Router({
    linkActiveClass: "activeItem",
    linkExactActiveClass: "activeItem",
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    routes: [{
        path: "/auth",
        name: "Auth",
        component: () =>
            import("@/pages/Auth.vue"),
        meta: {
            clearLayout: true
        }
    },
    {
        path: "/",
        redirect: { name: "Assets" }
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: () =>
            import("@/pages/Dashboard")

    },
    {
        path: "/events",
        name: "Events",
        component: Events
    },
    {
        path: "/logs",
        name: "Logs",
        component: Logs
    },
    {
        path: "/assets",
        name: "Assets",

        component: () =>
            import("@/pages/Assets"),
        children: [
            { path: "add", component: AddAssets, name: "AddAssets" },
            { path: "view/:id", component: SingleScope, name: "SingleScope" }
        ]
    },
    {
        path: "/triggers",
        name: "Triggers",
        component: () =>
            import("@/pages/Triggers"),

    },
    {
        path: "/wordlists",
        name: "Wordlists",
        component: Wordlists,
        children: [{
            path: "view/:id",
            component: SingleWordlist,
            name: "SingleWordlist"
        }]
    },
    {
        path: "/atoms/local",
        component: Atoms,
        name: "AtomsLocal"
    },
    {
        path: "/atoms/marketplace",
        component: Atoms,
        name: "AtomsMarketplace",
        props: { marketplace: true }
    },
    {
        path: "/atoms/new/:type",
        component: NewAtom,
        name: "NewAtom"
    },
    {
        path: "/atoms/view/:id",
        component: SingleAtom,
        name: "SingleAtom"
    },
    {
        path: "/nodes",
        name: "Nodes",
        component: Nodes,
       
    },
    {
        path: "/sched",
        name: "Sched",
        component: Sched,
        children: [
            { path: "view/:id", component: SingleSchedTask, name: "SingleSchedTask" }
        ]
    },
    { path: "/sched/new", component: NewTask, name: "NewTask" },
    {
        path: "/nodes/tasks",
        name: "Tasks",
        component: NodeTasks,
        children: [
            { path: "view/:id", component: SingleTask, name: "SingleNodeTask" }
        ]
    },
    { path: "/tasks/new_task", component: NewNodeTask, name: "NewNodeTask" },
    // templates
    {
        path: "/templates/",
        name: "Templates",
        component: Templates,

    },
    { path: "/templates/edit/:id", component: SingleTemplate, name: "SingleTemplate" },
    // vulnerabilities
    {
        path: "/vulnerabilities/",
        name: "Vulnerabilities",
        component: Vulnerabilities,
    },
    { path: "/vulnerabilities/edit/:id", component: SingleVulnerability, name: "SingleVulnerability" },
    // storage
    {
        path: "/storage/files",
        name: "StorageFiles",
        component: () =>
            import("@/pages/Storage"),
        props: { view: "files" },

    },
    { path: "/storage/files/edit/:hash", component: EditFile, name: "EditFile" },
    // { path: "/storage/kv/:space", component: Storage, name: "SingleStorageKV",props: { view: "kv" }, },
    {
        path: "/storage/kv",
        name: "StorageKV",
        component: Storage,
        props: { view: "kv" },
        children: [
            { path: ":space", component: Storage, name: "SingleStorageKV", }
        ]
    },
    {
        path: "/storage/tables",
        name: "StorageTables",
        component: Storage,
        props: { view: "tables" }
    },
    
    
    //
    {
        path: "/lua-engine",
        name: "LuaEngine",
        component: () =>
            import("@/pages/LuaEngine"),
    },
    {
        path: "/web-engine",
        name: "WebEngineView",
        component: () =>
            import("@/pages/WebEngineView"),
    },
    {
        path: "/settings",
        name: "Settings",
        component: () =>
            import("@/pages/Settings"),
    },
    {
        path: "/settings/team",
        name: "SettingsTeam",
        component: SettingsTeam
    },
    {
        path: "/test",
        component: Test,
        name: "Test"
    }
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js